import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full p-0 border-0" }
const _hoisted_2 = {
  class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1",
  for: "name"
}
const _hoisted_3 = ["id", "placeholder", "required", "disabled"]
const _hoisted_4 = { class: "mt-2 text-sm text-red-2 dark:text-red-2" }
const _hoisted_5 = ["id"]

import { shallowRef, computed, ref, onMounted } from "vue";
import { useStore } from "vuex";

import { defineEmits } from "@vue/runtime-core";
import * as dtos from "@/models/dtos";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputText',
  props: {
  model: {
    required: true,
    type: String,
  },
  keyId: String,
  placeholder: String,
  label: String,
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change", "customChange"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const store = useStore();
const containerByDNS = ref<Profile>(null);
const props = __props;
let model = shallowRef(props?.model);

function customChange(event: any) {
  emit("change", model.value);
  emit("customChange", model.value);
}
function createProperty(
  placeholder: string,
  type: string
): dtos.DynamicProperty {
  const item = new dtos.DynamicProperty();
  item.placeholder = placeholder;
  item.type = type;
  return item;
}

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(props.label), 1),
    _withDirectives(_createElementVNode("input", {
      onInput: customChange,
      type: "text",
      class: "appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-1 sm:py-3 px-4 leading-tight focus:bg-white focus:border-blue-2 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed",
      id: __props.keyId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
      placeholder: props.placeholder,
      required: props.required ? true : null,
      disabled: props.disabled ? true : null
    }, null, 40, _hoisted_3), [
      [_vModelText, _unref(model)]
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createElementVNode("span", {
        class: "font-medium",
        id: 'error_' + __props.keyId
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})